import { Component, OnInit } from '@angular/core';
import { Option } from '@layouts/external-authenticated-layout/options';
import { Building2, LayoutDashboard, ShieldPlus, UserPen, Users, Mail, List } from 'lucide-angular';
import { RouterOutlet } from '@angular/router';
import { MenuOptionsService } from '@shared/services/menu-option-service';

@Component({
  selector: 'company-management',
  imports: [RouterOutlet],
  templateUrl: './company-management.html',
  styleUrl: './company-management.scss',
})
export class CompanyManagement implements OnInit {
  options: Option[] = [
    {
      title: 'Dashboard',
      icon: LayoutDashboard,
      route: '/external-services/company-management/company-dashboard',
      isEnabled: true,
    },
    {
      title: 'Company Profile',
      icon: Building2,
      route: '/external-services/company-management/company-profile',
      isEnabled: true,
      permissions: ['ROLE_REGISTRATION_COMPANY_REGISTER']
    },
    {
      title: 'Company Staffs',
      icon: Users,
      route: '/external-services/company-management/company-staffs-management',
      isEnabled: true,
      permissions: ['ROLE_COMPANY_USERS_VIEW'],
    },
    {
      title: 'Roles & Permission',
      icon: ShieldPlus,
      route: '/external-services/company-management/company-roles-permissions-management',
      isEnabled: true,
      permissions: ['ROLE_USER_ROLES_VIEW'],
    },
    {
      title: 'Company Letters',
      icon: Mail,
      route: '/external-services/company-management/company-registration-letters',
      isEnabled: true,
      permissions: ['ROLE_REGISTRATION_COMPANY_LETTERS_VIEW'],
    },
    {
      title: 'Company Consignees',
      icon: List,
      route: '/external-services/company-management/company-consignees',
      isEnabled: true,
    },
  ];

  constructor(private menuOptionsService: MenuOptionsService) {}

  ngOnInit(): void {
    this.menuOptionsService.clearMenuOptions();
    this.menuOptionsService.setOptions(this.options);
  }

  ngOnDestroy() {
    this.menuOptionsService.setOptions([]);
  }
}
